import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Menu } from '@headlessui/react';

import Img from '../../components/Img';
import { buildUserShortName } from '../../utils/helpers';
import MessageContainer from '../message/message.container';
import Button from '../../components/Button';
import { LanguageSelector } from '../../../../common/localization';

const adminRoles = ['super_admin', 'admin', 'lecturer'];

export default function UserBar({ locales: { userbar }, locales }) {
  const {
    user: { current },
  } = useSelector((state) => state);
  const {
    user: { fetchCurrentUser },
  } = useDispatch();

  const rolesNamesMapping = {
    super_admin: locales.admin.superAdmin,
    admin: locales.admin.admin,
    lecturer: locales.admin.educator,
  };

  useEffect(() => {
    if (!current.id) fetchCurrentUser();
  }, []);

  const userbarLabelClick = () => {
    if (adminRoles.includes(current.role)) {
      window.location = '/admin';
    }
  };

  return (
    <div className="bmc-userbar">
      {rolesNamesMapping[current.role] && (
        <Button className="bg-primary" onClick={userbarLabelClick}>
          {rolesNamesMapping[current.role]}
        </Button>
      )}

      <MessageContainer />
      <div className="mr-4">
        <LanguageSelector />
      </div>
      <Menu>
        <Menu.Button className="bmc-userbar-avatar">
          {current.imageIcon && current.role !== 'super_admin' ? (
            <Img src={current.imageIcon} />
          ) : (
            <div className="bmc-userbar-avatar-nophoto">
              {buildUserShortName(current)}
            </div>
          )}
          <div className="bmc-userbar-avatar-arrow">
            <i className="icon-Colaps" />
          </div>
        </Menu.Button>
        <Menu.Items className="bmc-userbar-menu">
          <Menu.Item>
            {({ active }) => (
              <a href="/account">
                <div
                  className={`bmc-userbar-menu-item ${
                    active && 'bmc-userbar-menu-item-active'
                  }`}
                >
                  <i className="icon-CS green" />
                  {userbar.account}
                </div>
              </a>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <div
                className={`bmc-userbar-menu-item ${
                  active && 'bmc-userbar-menu-item-active'
                }`}
                onClick={() => (window.location = '/users/sign_out')}
              >
                <i className="icon-VP green" />
                {userbar.logout}
              </div>
            )}
          </Menu.Item>
        </Menu.Items>
      </Menu>
    </div>
  );
}
